import { render, staticRenderFns } from "./HomeServiceTypeServiceTotalFee.vue?vue&type=template&id=9acd9e94&scoped=true&"
import script from "./HomeServiceTypeServiceTotalFee.vue?vue&type=script&lang=js&"
export * from "./HomeServiceTypeServiceTotalFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9acd9e94",
  null
  
)

export default component.exports